<template>
    <v-expansion-panel
        v-model="value"
        expand
        class="mb-4"
    >
        <v-expansion-panel-content
            v-for="(item_list,index) in content"
            :key="index"
            expand-icon=""
            class="database-content"
        >
            <v-layout slot="header">
                <v-flex>{{ item_list.content.title }}</v-flex>
                <roundButton :icon_name="value[index] ? 'minus' : 'plus'" :class="{'btn--icon-white': value[index]}" />
            </v-layout>
            <v-card class="mb-4" v-html="item_list.content.text">
                <!-- <component :content="content_item.content" :is="content_item.type" /> -->

            </v-card>
        </v-expansion-panel-content>
    </v-expansion-panel>
</template>

<script>
import listCards   from '@/components/view_blocks/Database/list_blocks/list_cards';
import listTabs   from '@/components/view_blocks/Database/list_blocks/list_tabs';
import listTable   from '@/components/view_blocks/Database/list_blocks/list_table';
import listText   from '@/components/view_blocks/Database/list_blocks/list_text';
import roundButton   from '@/components/ui/buttons/buttons_icon/round_button';
import {mapGetters} from 'vuex';

export default {
  components: {
    listCards,
    listTabs,
    listTable,
    listText,
    roundButton,
  },
  props: {
    content: {
      type: Array,
    },
  },
  data() {
    return {
      pagination: {
        sortBy: 'name',
      },
      value: [],
    };
  },
  computed: {

  },
};
</script>

<style>

</style>
